export const proposalData = {
  createdAt: '2025-12-12T12:00:00Z',
  company: {
    name: 'Innovate Solutions Inc.',
    logo: '', // Mock logo if needed
    industry: 'Software Development',
  },
  project: {
    title: 'Strategic Digital Transformation Project',
    description:
      'Innovate Solutions Inc. is seeking a partner to lead a comprehensive digital transformation initiative. This project involves modernizing our legacy systems, implementing new cloud-based infrastructure, and enhancing our customer-facing platforms. The goal is to improve operational efficiency, reduce costs, and deliver a superior customer experience. We are looking for a highly experienced firm with a proven track record in large-scale enterprise solutions and a deep understanding of agile methodologies.',
    scope:
      'The project scope includes a full audit of current systems, development of a new enterprise architecture, migration of data to a secure cloud environment, deployment of a new CRM and ERP system, and integration with existing third-party tools. It also covers training for internal teams and post-implementation support for 6 months.',
    requirements: [
      'Minimum 5 years experience in enterprise-level digital transformation.',
      'Expertise in AWS or Azure cloud platforms.',
      'Strong proficiency in CRM (e.g., Salesforce) and ERP (e.g., SAP) implementations.',
      'Proven ability to manage complex projects with cross-functional teams.',
      'Excellent communication and stakeholder management skills.',
      'Provide a detailed project plan with clear milestones and deliverables.',
    ],
  },
  milestones: [
    {
      name: 'Discovery & Planning',
      compensation: '$15,000',
      originalTimeline: '2025-12-30',
      adjustedTimeline: '2025-12-30',
    },
    {
      name: 'Architecture Design',
      compensation: '$25,000',
      originalTimeline: '2025-05-15',
      adjustedTimeline: '2025-05-15',
    },
    {
      name: 'Cloud Migration',
      compensation: '$40,000',
      originalTimeline: '2025-06-30',
      adjustedTimeline: '2025-06-30',
    },
    {
      name: 'System Implementation',
      compensation: '$60,000',
      originalTimeline: '2025-08-15',
      adjustedTimeline: '2025-08-15',
    },
    {
      name: 'Testing & Deployment',
      compensation: '$30,000',
      originalTimeline: '2025-09-30',
      adjustedTimeline: '2025-09-30',
    },
  ],
  totalCompensation: '$170,000',
  terms: [
    'Confidentiality: All information exchanged during the project will be treated as strictly confidential.',
    'Payment Terms: Payments will be made within 15 days of invoice submission upon completion of each approved milestone.',
    'Intellectual Property: All intellectual property developed during the project will be owned by Innovate Solutions Inc.',
    'Termination: Either party may terminate the agreement with 30 days written notice.',
    'Governing Law: This agreement shall be governed by and construed in accordance with the laws of Germany.',
    'Force Majeure: Neither party shall be liable for any delay or failure in performance due to causes beyond their reasonable control.',
    'Amendments: Any amendments to this contract must be made in writing and signed by both parties.',
    'Entire Agreement: This document constitutes the entire agreement between the parties and supersedes all prior discussions.',
  ],
};
